import React from "react";
import axios from "axios";
import { NavLink } from "react-router-dom";
import {
  FaHome,
  FaUsers,
  FaUser,
  FaRegBuilding,
  FaRegUserCircle,
  FaChartBar,
} from "react-icons/fa";
import { BiLogOut } from "react-icons/bi";
import styled from "styled-components";
import { cssVar, lighten } from "polished";
import { useSelector } from "react-redux";

import logo from "@assets/images/roofing-done-wright-logo.png";
import { size, device } from "@util/breakpoints";
import { getRoleInfo } from "@util/roleInfo";

const NavWrapper = styled.div`
  display: flex;
  background: var(--navBackgroundColor);
  flex-direction: column;
  width: 15%;
  max-width: 260px;
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  padding: 5px 0px 25px 0px;
  overflow-y: auto;
  /* z-index: 9999; */

  @media (max-width: ${size.tablet}) {
    position: relative;
    top: 0;
    width: 100%;
    max-width: 100%;
    padding: 0 0 15px 0;
    height: auto;
  }

  @media (min-width: 770px) and (max-width: 920px) {
    /* width: 98%; */
  }

  img {
    width: 200px;
    padding: 10px;
    margin: 0 auto;
    display: block;

    @media (min-width: 770px) and (max-width: 1199px) {
      display: none !important;
    }

    @media (max-width: ${size.tablet}) {
      width: 125px;
      padding: 0;
      display: none;
    }
  }

  .links {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    margin-top: 30px;

    @media (max-width: ${size.tablet}) {
      flex-direction: row;
      margin-top: 10px;
      overflow-x: auto;
      justify-content: center;
      align-items: center;
      flex-grow: 0;
    }
  }

  a {
    color: #ebebeb;
    font-weight: 600;
    padding: 20px 3px;
    font-size: 1.05em;
    display: flex;
    align-items: center;
    justify-content: start;
    margin-left: 17px;
    margin-right: 17px;
    opacity: 0.7;
    border-left: 4px solid transparent;

    @media (max-width: ${size.tablet}) {
      padding: 5px 1px;
      font-size: 0.95em;
      margin-left: 5px;
      margin-right: 5px;
    }

    span.text {
      @media (max-width: 1058px) {
        display: none;
      }
    }

    span {
      margin-left: 20px;
    }

    &:hover {
      color: white;
      opacity: 0.95;
    }

    &.active {
      color: ${() => `${cssVar("--primaryColorLight")}`};
      opacity: 1;
      border-left: ${() =>
        `3px solid ${cssVar("--primaryColorLight")}`};
      border-radius: 0px;

      @media (max-width: ${size.tablet}) {
        border-color: transparent;
      }
    }

    svg {
      margin-left: 25px;
      font-size: 1.25em;

      @media (min-width: 1059px) {
        display: none;
      }
    }
  }

  .admin-info {
    color: #fff;
    font-weight: 100;
    text-align: center;
    margin: 10px auto 0 auto;
    opacity: 0.25;
  }
  
  span.logout {
    font-size: .5em;
    display: flex;
    align-items: center; /* Vertical centering */
    justify-content: center; /* Horizontal centering, if needed */
  }

  button {
    background-color: transparent;
    border: none;
    outline: none;
    padding: 10px;
    margin: 0 auto 5px auto;
    width: fit-content;
    color: #fff;
    cursor: pointer;
    font-size: 24px;
    opacity: 0.45;

    &:hover {
      opacity: 1;
    }

    @media (max-width: ${size.tablet}) {
      display: none;
    }
  }
`;

export default function Nav({ admin }) {
  function logout(e) {
    e.preventDefault();

    const url = admin ? `/logout/` : `/logout/`;

    axios
      .post(url)
      .then(() => {
        window.location = admin ? `/admin` : "/";
      })
      .catch(() => {
        window.location = "/";
      });
  }

  const storeInfo = useSelector((state) => state);
  const roleInfo = getRoleInfo(storeInfo);
  const adminInfo = storeInfo.admin;
  const representativeInfo = storeInfo.representative;
	
  const linkset = admin
    ? adminLinks.filter((f) =>
        roleInfo.admin_partial || roleInfo.admin_view_only
          ? !["admins"].includes(f.name)
          : true
      )
    : representativeLinks
        .filter((f) =>
          !roleInfo.manager_view
            ? !["managed reps"].includes(f.name)
            : true
        );

  return (
    <NavWrapper>
      <img src={logo} alt="Roofing Done Wright Payroll" />
      <div className="links">
        {linkset.map(({ key, text, path, icon }) => (
          <NavLink key={key} to={path}>
            {icon} <span className="text">{text}</span>
          </NavLink>
        ))}
      </div>
      {adminInfo && (
        <div className="admin-info">{adminInfo.access_formatted}</div>
      )}
      <button onClick={logout} title="Logout">
        <BiLogOut /> <span className="logout">Logout</span>
      </button>
    </NavWrapper>
  );
}

Nav.defaultProps = {
  admin: false,
};

const representativeLinks = [
  {
    text: "Jobs",
    path: `/jobs`,
  },
  {
    text: "Payments",
    path: `/payments`,
  },
  {
    text: "Reports",
    path: `/reports`,
  },
  {
    text: "- Commissions",
    path: `/commissions`,
  },
  {
    text: "- Reimbursements",
    path: `/reimbursements`,
  },
  {
    text: "- Draws",
    path: `/draws`,
  },
  {
    text: "Managed Reps",
    path: `/representatives`,
  },
  {
    text: "Profile",
    path: `/representative-profile`,
  },
].map((m, i) => ({ ...m, key: i + 1, name: m.text.toLowerCase() }));

const adminLinks = [
  // {
  //   text: "DASHBOARD",
  //   path: `/dashboard`
  //  },
   {
     text: "ACH",
     path: `/ach`,
   },
   { 
     text: "JOBS",
     path: `/jobs` 
   },
  { 
    text: "REPRESENTATIVES",
    path: `/representatives` 
  },
  {
    text: "-- Commissions",
    path: `/representative-payments`,
  },
  {
    text: "-- Points",
    path: `/manager-payments`,
  },
  {
    text: "-- Reimbursements",
    path: `/representative-invoices`,
  },
  {
    text: "-- Salaries",
    path: `/salary-payments`,
  },
  {
    text: "-- Knocking",
    path: `/knocking-payments`,
  },
  {
    text: "-- Draws",
    path: `/representative-draws`,
  },
  {
    text: "-- Bonuses",
    path: `/representative-bonuses`,
  },
  {
    text: "-- Corrections",
    path: `/representative-corrections`,
  },
  {
    text: "CONTRACTORS",
    path: `/contractors`,
  },
  {
    text: "-- Invoices",
    path: `/contractor-invoices`,
  },
  {
    text: "-- Payments",
    path: `/contractor-payments`,
  },
  // {
  //   text: "REPORTS",
  //   path: "/reports"
  //  },
  {
    text: "ADMINS",
    path: "/admins",
  },
  {
    text: "My Profile",
    path: "/profile",
  },
].map((m, i) => ({ ...m, key: i + 1, name: m.text.toLowerCase() }));
